import { User } from "../models/User";
import { UserFilter } from "../models/UserFilter";
import { fetchWithAuthentication } from "../utilities/FetchUtil";

export const getUsersWithFilters = async (
    setLoading: (newValue: boolean) => void,
    userFilter: UserFilter,
    setTotalPages: (newValue: number) => void,
    setTotalUsers: (newValue: number) => void,
): Promise<User[]> => {
    setLoading(true);

    if (userFilter.pageNum < 0) {
        setLoading(false);
        return [];
    }

    try {
        const response = await fetchWithAuthentication('/user', "POST", userFilter)
        const data = await response.json();
        setTotalPages(data.totalPages);
        setTotalUsers(data.totalElements);
        return data.users || [];
    } catch (error) {
        console.error('Error fetching users:', error);
        return [];
    } finally {
        setLoading(false);
    }
};
